import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { ProductTransactionFlow } from '../../../../../../../store/transactionFlow/types';
import { NotFoundTable, ProductFieldProps } from '../../constants';

import { AssetItem, AssetWithDocument } from './components/AssetItem';
import { AssetsList } from './components/AssetsList';
import { ProductTabletCard } from './components/ProductTabletCard';

export interface ProductTableTabletProps<T> {
  data: T[];
  fields: ProductFieldProps<T>[];
  columns: number;
  product: ProductTransactionFlow;
  rows?: number;
  loading?: boolean;
  onSelectClient: (cpfCnpj: string) => void;
}

export const ProductTableTablet = <T extends AssetWithDocument>({
  data,
  product,
  fields,
  columns,
  rows,
  loading,
  onSelectClient,
}: ProductTableTabletProps<T>) => {
  const renderItem = (label: string, value: string | number, item: T) => (
    <AssetItem
      columns={columns}
      label={label}
      value={`${value}`}
      item={item}
      onSelectClient={onSelectClient}
    />
  );

  const renderProductItem = (item: T, index: number) => (
    <ProductTabletCard index={index} product={product}>
      <AssetsList
        id="flatList-dynamicTable-detail"
        keyExtractor={(field) => `${field.label}`}
        data={fields}
        renderItem={({ item: field }) =>
          renderItem(field.label, item[field.key] as string | number, item)
        }
        rows={rows}
        columns={columns}
      />
    </ProductTabletCard>
  );

  if (data?.length === 0 && !loading) {
    return <NotFoundTable />;
  }

  return (
    <VStack space={Spacing['stack.xxxs']} pb={Spacing['stack.xxxs']}>
      {data.map((item, index) => renderProductItem(item, index))}
    </VStack>
  );
};
